/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import * as web3Service from '../blockchain/web3.service'

export const useUserEarningSorFar = (props) => {

  const { accountAddress } = props
  const [userAvailableEarning, setUserAvailableEarning] = useState(null)
  const [isLoading, setLoading] = useState(false)
  const [animatedClass, setAnimatedClass] = useState('')

  useEffect(() => {
    fetchUserEarnings()
  }, [accountAddress])

  const fetchUserEarnings = async () => {
    try {
      setLoading(true)
      setAnimatedClass('')
      const userAvailableEarningResponse = await web3Service.getUserAvailableEarningSoFar(accountAddress)
      setUserAvailableEarning(userAvailableEarningResponse)
      setAnimatedClass('animate__heartBeat')
    } catch (error) {
      setUserAvailableEarning(null)
      console.error('error while getting user available earning ', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchUserEarnings()
    }, 25000)

    return () => clearInterval(intervalId)

  }, [accountAddress])

  return { userAvailableEarning, isLoading, animatedClass }
}

export default useUserEarningSorFar

